export const DEFAULT_APPEARANCE_PALETTE: readonly string[] = ['#6c63ff', '#ff6b35', '#e96ac5', '#3892f0', '#34e1e6'];

export const APPEARANCE_COLOR_PICKER_Z_INDEX = 60;
